export const siteChromeNavigationStoreKey = "Asos.SiteChrome.Navigation";
export const expirationInMs = 5 * 60 * 1000;
export const ALWAYS_INCLUDED_BENEFIT_TYPES = ["EarlyAccessToNewIn"];
export const LOGGED_IN = "LoggedIn";
export const LOGGED_OUT = "LoggedOut";
export const PREMIER = "Premier";
export const NON_PREMIER = "NonPremier";
export const OPTED_OUT = "OptedOut";
export const EARLY_ACCESS_TO_NEW_IN_BENEFIT_TYPE = "EarlyAccessToNewIn";
